import { convertToPercent } from '@openx/utils/lib/convertToPercent.ts';

export const formatSegmentPrice = (pom?: number, cpm?: number): string | null => {
  const normalizedPom = Number(pom);
  const normalizedCpm = Number(cpm);

  if (!Number.isFinite(normalizedPom) || !Number.isFinite(normalizedCpm)) return null;
  if (normalizedPom === 0 && normalizedCpm === 0) return null;

  return `${convertToPercent(normalizedPom)}% / $${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(normalizedCpm)}`;
};
